import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import womenBodymapAnterior from '../../images/bodymap/women-bodymap-anterior.webp';
import womenBodymapPosterior from '../../images/bodymap/women-bodymap-posterior.webp';
import womenBodymapFace from '../../images/bodymap/women-bodymap-face.webp';
import womenBodymapFace2 from '../../images/bodymap/women-bodymap-face-2.webp';
import womenBodymapUnderarms from '../../images/bodymap/women-bodymap-underarms.webp';
import womenBodymapBikiniArea from '../../images/bodymap/women-bodymap-bikini-area.webp';

export function BodymapWomenCarousel() {
    return (
        <Carousel>
            <Carousel.Item>
                <img className="d-block w-100" src={womenBodymapAnterior} alt="Women Bodymap Anterior" />
            </Carousel.Item>
            <Carousel.Item>
                <img className="d-block w-100" src={womenBodymapPosterior} alt="Women Bodymap Posterior" />
            </Carousel.Item>
            <Carousel.Item>
                <img className="d-block w-100" src={womenBodymapFace} alt="Women Bodymap Face" />
            </Carousel.Item>
            <Carousel.Item>
                <img className="d-block w-100" src={womenBodymapFace2} alt="Women Bodymap Face 2" />
            </Carousel.Item>
            <Carousel.Item>
                <img className="d-block w-100" src={womenBodymapUnderarms} alt="Women Bodymap Underarms" />
            </Carousel.Item>
            <Carousel.Item>
                <img className="d-block w-100" src={womenBodymapBikiniArea} alt="Women Bodymap Bikini Area" />
            </Carousel.Item>
        </Carousel>
    );
}

export default BodymapWomenCarousel;
